import { fromDate as e, toDate as t } from "./dateValue.js";
import { useCallback as n, useEffect as r, useRef as i, useState as a } from "react";
//#region lib/components/DatePicker/useDateField.ts
function o(e, t) {
	e && (typeof e == "function" ? e(t) : e.current = t);
}
function s(e) {
	let t = i(null);
	return r(() => {
		o(e, t.current);
	}, [e]), t;
}
function c(r) {
	let { value: i, defaultValue: o, format: s, timeZone: c } = r, l = i !== void 0, [u, d] = a(() => o), [f, p] = a(i);
	i !== f && (p(i), i === void 0 ? f !== void 0 && d(void 0) : d(i));
	let m = l ? i : u, h = n((t) => {
		let n = e(t, s, c);
		return l || d(n), n;
	}, [
		s,
		l,
		c
	]);
	return {
		value: m,
		date: t(m, s, c),
		commit: h
	};
}
function l(e, t) {
	let { name: r, onValueChange: i, onChange: a, registerOnChange: o } = t;
	return n((t) => {
		let n = e(t);
		i?.(n), a?.({ target: {
			name: r,
			value: n
		} }), o?.({ target: {
			name: r,
			value: n
		} });
	}, [
		e,
		r,
		i,
		a,
		o
	]);
}
function u(e) {
	let [t, r] = a(!1);
	return {
		open: t,
		setOpen: r,
		handleOpenChange: n((t) => {
			r(t), t || e?.();
		}, [e])
	};
}
//#endregion
export { o as assignRef, c as useControlledDate, l as useDateEmitter, u as usePopoverOpen, s as useSyncedRef };
